// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vuRX","buttons":"styles_buttons__3Vym9"};